import { ProductTourActionsE } from '../../../models/enums';

/**
 * Add new tour's data here.
 *
 * Tour name should be the same as the page name, where you want this tour will be shown
 * Only one tour per one page
 *
 * */
export const tours = {
  // Should be the same name as page name, eg.: jumbomail.me/inbox <--
  'campaigns adv': {
    // Which element do you want to be highlighted
    "#campaigns-menu-item": [],
    "#deliveries-menu-item": [],
    "#search-campaign": [],
    "#add-campaign-button": [],
    "#create-delivery-button": [],
    "#filter-by-status-wrapper": [
      { element: "#hidden-span", actionName: "click" },
    ],
    "#settings-menu-item": [],
    // ".select-options-list": [
    //   { stepNumber: 4, element: ".select-list-icon", actionName: "click" },
    // ],
  },
  'campaigns pst': {
    "#campaigns-menu-item": [],
    "#deliveries-menu-item": [
      { element: "#hidden-span", actionName: "click" },
    ],
    "#search-delivery": [],
    "#first-delivery-number": [],
    "#filter-by-status-wrapper": [],
    "#settings-menu-item": [],
  },
  'campaigns brd': {
    "#campaigns-menu-item": [],
    "#deliveries-menu-item": [],
    "#search-campaign": [],
    "#add-campaign-button": [],
    "#filter-by-status-wrapper": [
      { element: "#hidden-span", actionName: "click" },
    ],
    "#first-delivery-number": [],
    "#settings-menu-item": [],
  },
};
